import { render, staticRenderFns } from "./FollowingStudents.vue?vue&type=template&id=400217ad&scoped=true&"
import script from "./FollowingStudents.vue?vue&type=script&lang=js&"
export * from "./FollowingStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400217ad",
  null
  
)

export default component.exports